import { Account } from '@core/model/domain/account';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';

export class SelectAccountsVM {
  constructor(private processEventService: ProcessEventService) {}

  async submit(selectedAccounts: Account[]) {
    this.processEventService.push(ProcessEventFactory.SpawnAccountsSelectedEvent({ selectedAccounts }));
  }
}
